<script lang="ts" setup>
import IconChevron from '@/assets/icons/chevron.svg?component'

defineProps<{
  hasBackButton?: boolean
  hasHeader?: boolean
}>()

const emit = defineEmits<{
  (e: 'back'): void
}>()
</script>

<template>
  <div class="PageTransition">
    <div class="Layout">
      <div v-if="hasHeader !== false" class="MainHeader">
        <div class="MainHeader__Left">
          <div class="MainHeader__NavButton" @click="emit('back')">
            <span><IconChevron class="Header__IconChevron" />Back</span>
          </div>
        </div>
      </div>
      <main class="Layout__Container PageTransition__Target">
        <slot></slot>
      </main>
      <div class="SimpleLayout__ActionFooter">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
